"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const typography_1 = require("../styles/typography");
/**
 * The element to be used as buttons in Ops Portal.
 */
exports.Button = styled_components_1.default.button `
  ${typography_1.defaultText}

  background: transparent;
  border: 1px ${(props) => props.theme.colors.primaryAccent} solid;
  border-radius: ${(props) => props.theme.borderRadius};
  appearance: none;

  position: relative;
  padding: 10px ${(props) => props.theme.spacing.m};
  min-width: 80px;

  color: ${(props) => props.theme.colors.primaryAccent};
  font-family: ${(props) => props.theme.font.family.sans};
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
  user-select: none;
  cursor: pointer;

  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;

  ${(props) => props.inline &&
    `
    display: inline-flex;
    width: auto;
  `}

  &:hover {
    border-color: ${(props) => props.theme.colors.primaryAccentHover};
    color: ${(props) => props.theme.colors.primaryAccentHover};
  }

  &:focus-visible {
    outline: ${(props) => props.theme.outline};
    outline-offset: 1px;
  }

  &[disabled] {
    background: ${(props) => props.theme.colors.backgroundInactive};
    color: ${(props) => props.theme.colors.textInactive};
    cursor: default;
    pointer-events: none;
  }

  ${(props) => props.primary &&
    `
    color: ${props.theme.colors.white};
    border: none;
    background: ${props.theme.colors.primaryAccent};
    font-weight: ${props.theme.font.weight.medium};

    &:hover {
      color: white;
      border: none;
      background: ${props.theme.colors.primaryAccentHover};
    }

    &[disabled] {
      color: ${props.theme.colors.textInactive};
      background: ${props.theme.colors.backgroundInactive};
    }
  `}

  ${(props) => props.inverse &&
    `
    color: white;
    border: none;
    background: rgba(255, 255, 255, 0.1);

    &:hover {
      color: white;
      border: none;
      background: rgba(255, 255, 255, 0.3);
    }
  `}

  ${(props) => props.small &&
    styled_components_1.css `
      ${typography_1.smallText}
      padding-left: 12px;
      padding-right: 12px;
    `}

  ${(props) => props.link &&
    `
    background: none;
    height: auto;
    border: none;
    line-height: inherit;
    padding-left: 0px;
    padding-right: 0px;
    min-width: 0px;
    color: ${props.theme.colors.primaryAccent};

    &:hover {
      background: none;
      color: ${props.theme.colors.primaryAccent};
    }
  `}
`;
exports.default = exports.Button;
